import React, { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import { isValidPhoneNumber } from "libphonenumber-js";
import axios from "axios";
import ErrorModal from "../elements/ErrorModal"; // Adjust the import path as needed

function SectionCTA() {
  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://akord.rs/api"
      : "http://localhost:15510/api";

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pib, setPib] = useState(""); // State for PIB
  const [message, setMessage] = useState("");
  const [botCheck, setBotCheck] = useState(""); // Honeypot state
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility
  const [modalMessage, setModalMessage] = useState(""); // State to manage modal message
  const [isSubmitting, setIsSubmitting] = useState(false); // State to manage loading during API call

  const handleEmailClick = async (event) => {
    event.preventDefault(); // Prevent the form from submitting

    // Validate all fields
    if (
      fullName === "" ||
      email === "" ||
      phone === "" ||
      pib === "" ||
      message === ""
    ) {
      setModalMessage("Sva polja moraju biti popunjena.");
      setShowModal(true);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setModalMessage("Unesite važeću email adresu.");
      setShowModal(true);
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      setModalMessage("Unesite važeći broj telefona.");
      setShowModal(true);
      return;
    }

    const pibRegex = /^\d{9}$/;
    if (!pibRegex.test(pib)) {
      setModalMessage("PIB mora sadržati tačno 9 cifara.");
      setShowModal(true);
      return;
    }

    setIsSubmitting(true);

    // Map data to the backend DTO model
    const formData = {
      UserFullName: fullName,
      UserEmail: email,
      UserPhone: phone,
      CompanyPib: pib,
      Message: message,
      BotCheck: botCheck, // Honeypot field sent to backend
    };

    try {
      // Call the new MVC API endpoint using axios and API_URL
      const response = await axios.post(
        `${API_URL}/Login/Korisnik/PosaljiKontaktEmail`,
        formData
      );

      if (response.status === 200) {
        // Use the message from backend if it exists, otherwise use default
        const successMessage =
          response.data?.Message ||
          (typeof response.data === "string" ? response.data : null) ||
          "Vaša poruka je uspešno poslata! Kontaktiraćemo Vas ubrzo.";

        setModalMessage(successMessage);
        setShowModal(true);

        // Clear the form fields on success
        setFullName("");
        setEmail("");
        setPhone("");
        setPib("");
        setMessage("");
        setBotCheck("");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      const errorMessage =
        error.response?.data?.Message ||
        error.response?.data ||
        "Greška u komunikaciji sa serverom. Proverite internet konekciju i pokušajte ponovo.";
      setModalMessage(errorMessage);
      setShowModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handlePibChange = (event) => {
    setPib(event.target.value);
  };

  const handleBotCheckChange = (event) => {
    setBotCheck(event.target.value);
  };

  const handleMessageChange = (event) => {
    const messageText = event.target.value;
    if (messageText.length <= 300) {
      setMessage(messageText);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <section className="section-cta" id="cta">
      <div className="container">
        <div className="cta">
          <div className="cta-text-box">
            <h2 className="heading-secondary">Želite više informacija?</h2>
            <p className="cta-text">
              Ostavite Vaše podatke da možemo da Vas kontaktiramo. Biće nam
              zadovoljstvo da razmotrimo zajedno sa Vama koja verzija našeg
              poslovnog softvera može najbolje da zadovolji Vaše potrebe!
            </p>

            <form className="cta-form" name="sign-up" netlify="true">
              {/* Honeypot field - invisible to humans */}
              <div style={{ display: "none" }}>
                <input
                  type="text"
                  name="bot-check"
                  value={botCheck}
                  onChange={handleBotCheckChange}
                  tabIndex="-1"
                  autoComplete="off"
                />
              </div>

              <div>
                <label htmlFor="full-name">Ime i prezime</label>
                <input
                  id="full-name"
                  type="text"
                  placeholder="Petar Petrović"
                  name="full-name"
                  value={fullName}
                  onChange={handleFullNameChange}
                  required
                />
              </div>

              <div>
                <label htmlFor="email">Email adresa</label>
                <input
                  id="email"
                  type="email"
                  placeholder="e-mejl adresa"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </div>

              <div>
                <label htmlFor="phone">Broj telefona</label>
                <input
                  id="phone"
                  type="tel"
                  placeholder="+381 64 123 4567"
                  name="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                  required
                />
              </div>

              <div>
                <label htmlFor="pib">PIB</label>
                <input
                  id="pib"
                  type="text"
                  placeholder="Broj sa 9 cifara"
                  name="pib"
                  value={pib}
                  onChange={handlePibChange}
                  required
                />
              </div>

              <div className="message-container">
                <label htmlFor="message">Poruka</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Vaša poruka"
                  value={message}
                  onChange={handleMessageChange}
                  maxLength="300"
                  required
                ></textarea>
                <p>{message.length}/300 karaktera</p>
              </div>

              <button
                className="btn btn--form"
                onClick={handleEmailClick}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Slanje..." : "Pošalji"}{" "}
                <FaEnvelope className="icon" />{" "}
              </button>
            </form>
          </div>
          <div
            className="cta-img-box"
            role="img"
            aria-label="Man with phone"
          ></div>
        </div>
      </div>
      {showModal && <ErrorModal message={modalMessage} onClose={closeModal} />}
    </section>
  );
}

export default SectionCTA;
